import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OohVisitsQueryVariables = Types.Exact<{
  oohId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type OohVisitsQuery = { __typename?: 'Query', OohVisits: Array<{ __typename?: 'OohCourierVisit', courierIndicative?: string | null, visitStartTime?: any | null, visitEndTime?: any | null, visitCharges?: any | null, visitDischargesC2C?: any | null, visitDischargesFirstMile?: any | null, visitDischargesExpired?: any | null, visitDischargesReturn?: any | null }> };


export const OohVisitsDocument = gql`
    query OohVisits($oohId: ID!, $date: Date) {
  OohVisits(date: $date, oohId: $oohId) {
    courierIndicative
    visitStartTime
    visitEndTime
    visitCharges
    visitDischargesC2C
    visitDischargesFirstMile
    visitDischargesExpired
    visitDischargesReturn
  }
}
    `;

/**
 * __useOohVisitsQuery__
 *
 * To run a query within a React component, call `useOohVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOohVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOohVisitsQuery({
 *   variables: {
 *      oohId: // value for 'oohId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOohVisitsQuery(baseOptions: Apollo.QueryHookOptions<OohVisitsQuery, OohVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OohVisitsQuery, OohVisitsQueryVariables>(OohVisitsDocument, options);
      }
export function useOohVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OohVisitsQuery, OohVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OohVisitsQuery, OohVisitsQueryVariables>(OohVisitsDocument, options);
        }
export type OohVisitsQueryHookResult = ReturnType<typeof useOohVisitsQuery>;
export type OohVisitsLazyQueryHookResult = ReturnType<typeof useOohVisitsLazyQuery>;
export type OohVisitsQueryResult = Apollo.QueryResult<OohVisitsQuery, OohVisitsQueryVariables>;